<template>
  <div class="page-container">
    <van-nav-bar
      left-arrow
      fixed
      title="我的红包"
      @click-left="goableBack()"
      :z-index="10"></van-nav-bar>
    <div class="page">
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list
          v-model="loading"
          :finished="finished"
          :finished-text="data.length > 0 ? '--- 我是有底线的 ---' : ''"
          class="list"
          @load="loadData">
          <div
            v-for="(n, i) of data"
            :key="`canuse-${i}`"
            class="item-bg"
            :class="isFebruaryActivity(n.createTime) ? 'item-bg-2' : ''">
            <div class="top-bg">
              <img
                src="../../assets/img/my-redpack/my_redpack_icon.png"
                alt="红包图标" />
              <div class="right-bg">
                <div v-if="isFebruaryActivity(n.createTime)" class="title">
                  开门红红包
                </div>
                <div v-else class="title">迎新年红包</div>
                <div class="date">
                  有效期：{{ dateFormat(n.createTime, "YYYY.MM.DD") }}-{{
                    dateFormat(n.expireTime, "YYYY.MM.DD")
                  }}
                </div>
              </div>
            </div>
            <!-- isReceived 是否已开奖 0 未开奖 1 已开奖 -->
            <div class="btn-bg">
              <template v-if="n.isExpired == true">
                <button class="btn">已过期</button>
              </template>
              <template v-else>
                <button
                  v-if="n.isReceived == 0"
                  class="btn"
                  @click="onOpenRedEnv(n)">
                  立即打开
                </button>
                <button v-else class="btn">已开奖</button>
              </template>
            </div>
          </div>
          <van-empty description="暂无记录" v-if="data.length == 0">
          </van-empty>
        </van-list>
      </van-pull-refresh>
    </div>
    <redenvelope-pop
      :visible.sync="showRedenvelopePop"
      :createTime="item.createTime"
      @onOpenClick="onOpenClick"></redenvelope-pop>
  </div>
</template>

<script>
import { List, Dialog, PullRefresh, Empty } from "vant"
import RedenvelopePop from "./redenvelopePop.vue"
import { getNewYearActivityList, operationRedPacket } from "../../api/market"
export default {
  name: "index",
  data: () => ({
    showRedenvelopePop: false,
    data: [],
    loading: false,
    finished: false,
    refreshing: false,
    item: {}
  }),

  methods: {
    isFebruaryActivity(createTime) {
      if (createTime) {
        if (
          this.dateFormat(createTime, "YYYY") == "2023" &&
          this.dateFormat(createTime, "MM") == "02"
        ) {
          return true
        }
      }
      return false
    },
    onRefresh() {
      this.finished = false
      this.loadData()
    },
    loadData() {
      this.loading = true
      getNewYearActivityList()
        .then((data) => {
          if (this.refreshing) {
            this.data = []
            this.refreshing = false
          }
          this.data = data
          this.loading = false
          this.finished = true
        })
        .catch((e) => {
          this.loading = false
          this.finished = true
          this.refreshing = false
          console.info(e)
          this.$toast(e.msg || e.message)
        })
    },
    onOpenClick() {
      operationRedPacket(this.item.id)
        .then((data) => {
          Dialog.confirm({
            title: "温馨提示",
            message:
              "恭喜您获得" + data + "积分，产品起息后可前往‘我的积分’列表查看",
            confirmButtonText: "确定"
          }).then(() => {})
          this.onRefresh()
        })
        .catch((e) => {
          this.$toast(e.msg || e.message)
        })
      this.showRedenvelopePop = false
    },
    onOpenRedEnv(item) {
      this.item = item
      this.showRedenvelopePop = true
    }
  },
  computed: {},
  components: {
    RedenvelopePop,
    [PullRefresh.name]: PullRefresh,
    [List.name]: List,
    [Empty.name]: Empty,
    [Dialog.name]: Dialog
  }
}
</script>

<style lang="less" scoped>
.introduce-img {
  width: 100%;
  object-fit: cover;
}
.list {
  margin: 0 15px;
  .item-bg {
    margin: 10px 0px 0px 0px;
    background-image: url("../../assets/img/my-redpack/my_redpack_bg.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    .top-bg {
      display: flex;
      // justify-content: space-between;
      align-items: center;
      margin: 0px 20px 0px 35px;
      padding-top: 10px;
      padding-bottom: 15px;
      border-bottom: 3px solid rgb(220, 186, 132);
      img {
        // width: 43px;
        // height: 54px;
        object-fit: cover;
      }
      .right-bg {
        color: white;
        margin-left: 20px;
        .title {
          text-align: center;
          font-size: 26px;
          letter-spacing: 3px;
          font-weight: 600;
          margin-bottom: 2px;
        }
      }
    }
    .btn-bg {
      display: flex;
      flex-direction: column;
      justify-content: center;
      padding: 5px 0;
      .btn {
        background-color: transparent;
        color: rgb(254, 219, 179);
        font-size: 15px;
        font-weight: 600;
        letter-spacing: 3px;
        border: 0;
      }
    }
  }
  .item-bg-2 {
    background-image: url("../../assets/img/my-redpack/my_redpack_bg_2.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
  }
  .bottom-button {
    width: 160px;
    height: 40px;
    background-color: #fc6524;
    border: none;
  }
}
</style>